import React, { useState, useEffect } from 'react'
import { Checkbox, Modal, Panel, Row, Table } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { downloadDurableArticlesFile } from '../../../redux/actions/accountingExpenses'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { downloadFile } from '../../../utils/fileUtil'
import notification from '../../../utils/notification'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function AssetRevolvingTable({
  schema,
  loading,
  disabled,
  page = 1,
  displayLength = 15,
  defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
    { value: 25, label: 25 },
    { value: 30, label: 30 },
  ],
  onReload = () => {},
  onSubmit = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])

  const [isSelectAll, setIsSelectAll] = useState()
  const [indeterminate, setIndeterminate] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  const [imgUrl, setImgUrl] = useState()
  const [isViewImg, setIsViewImg] = useState(false)

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  const delay = (delayInms) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms))
  }

  const onDisplayFile = async (data) => {
    try {
      const response = await downloadDurableArticlesFile(data.assetImg)

      if (response) {
        var blob = new Blob([response], { type: response.type })
        var urlCreator = window.URL || window.webkitURL
        var imageUrl = urlCreator.createObjectURL(blob)
        //console.log('id : ', `#${data.assetCode || data.id}`)
        var img = document.getElementById(`${data.assetCode || data.id}`)

        img.src = imageUrl
      }
    } catch (e) {
      console.log('error', e)
    }
  }

  const onDownloadFile = async (data) => {
    startLoading()
    try {
      const response = await downloadDurableArticlesFile(data.assetImg)

      if (response) {
        downloadFile(response, data.assetCode || data.id)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleOnConfirm = () => {
    onSubmit({ assetIds: checkedKeys })
    setIsShowConfirm(false)
  }

  const handleCheckAll = (value, checked) => {
    const checkedKeys = checked ? tableData.map((item) => item.id) : []
    setIndeterminate(false)
    setCheckedKeys(checkedKeys)
    setIsSelectAll(checked)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setIndeterminate(nextCheckedKeys?.length != tableData?.length)
    setCheckedKeys(nextCheckedKeys)
    setIsSelectAll(nextCheckedKeys?.length == tableData?.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 50}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: '40px' }}>
              <Checkbox
                inline
                checked={isSelectAll}
                indeterminate={indeterminate}
                onChange={(e, checked) => {
                  setIsSelectAll(checked)
                  handleCheckAll(null, checked)
                }}
              >
                <b>ลำดับ</b>
              </Checkbox>
            </div>
          </HeaderCell>
          <CheckCell
            dataKey="id"
            checkedKeys={checkedKeys}
            onChange={(value, checked) => {
              setIsSelectAll(false)
              handleCheck(value, checked)
            }}
          />
        </Column>
        <Column width={180}>
          <HeaderCell>รหัสโครงการที่คืน</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={200}>
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>
        <Column minWidth={300} width={300} flexGrow={1}>
          <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>
        <Column width={250}>
          <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetType" />
        </Column>
        <Column minWidth={250} width={250} flexGrow={1}>
          <HeaderCell>ยี่ห้อ</HeaderCell>
          <Cell dataKey="assetBrand" />
        </Column>
        <Column minWidth={250} width={250} flexGrow={1}>
          <HeaderCell>รุ่น</HeaderCell>
          <Cell dataKey="assetModel" />
        </Column>
        <Column width={180} align="center" fixed="right">
          <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
          {/* <Cell dataKey="QrPic" /> */}
          <Cell>
            {(rowData) => {
              if (isEmpty(rowData.assetImg)) {
                return <span style={{ color: '#fb8a81' }}>* ไม่มีรูปภาพ</span>
              }

              var img = ['jpg', 'jpeg', 'png']
              var fileType = rowData.assetImg.split('.')[1]

              if (img.includes(fileType)) {
                onDisplayFile(rowData)

                return (
                  <div style={{ width: '100%', minWidth: 100, height: 100 }}>
                    <img
                      id={rowData.assetCode || rowData.id}
                      alt="รูปภาพครุภัณฑ์"
                      style={{ width: '50%', minWidth: 100, height: 100, cursor: 'pointer' }}
                      onClick={(data) => {
                        setImgUrl(data.target.src)
                        setIsViewImg(true)
                      }}
                    />
                  </div>
                )
              } else {
                return (
                  <DownloadButton
                    onClick={() => {
                      onDownloadFile(rowData)
                    }}
                  ></DownloadButton>
                )
              }
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      {!disabled && (
        <Row style={{ textAlign: 'right' }}>
          <SaveButton
            children="นำเข้าสู่ระบบครุภัณฑ์หมุนเวียน"
            onClick={() => {
              if (checkedKeys?.length > 0) {
                setIsShowConfirm(true)
              } else {
                notification.open('error', {
                  title: 'กรุณเลือกครุภัณฑ์อย่างน้อย 1 รายการ',
                  duration: 5000,
                })
              }
            }}
          />
        </Row>
      )}

      <ConfirmWidget
        size="sm"
        title={`ยืนยัน`}
        show={isShowConfirm}
        detail={`ยืนยันการนำเข้าสู่ระบบครุภัณฑ์หมุนเวียน ${checkedKeys?.length} รายการ`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleOnConfirm}
      />

      <Modal
        show={isViewImg}
        size="md"
        onHide={(e) => {
          setIsViewImg(false)
          setImgUrl('')
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: 'auto', margin: '0 auto', width: '100%', textAlign: 'center' }}>
            <img
              id="view_img"
              src={imgUrl}
              alt="รูปภาพครุภัณฑ์"
              style={{ width: '70%', minWidth: 250, maxHeight: '90hv' }}
              className="contact-img "
            />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  )
}
